export const NOT_FOUND_CONSTANTS = {
  id: '404',
  title: 'Not Found',
  description: 'La página no existe!'
};
